import { Routes } from '@angular/router';

export const validationRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('../../pages/validations/validations').then((m) => m.Validations),
      },
      {
        path: 'validation-request',
        loadComponent: () =>
          import('../../pages/validations/validation-requests/validation-requests').then((m) => m.ValidationRequests),
      },
       {
        path: 'validation-whitelist',
        loadComponent: () =>
          import('../../pages/validations/validation-whitelist/validation-whitelist').then((m) => m.ValidationWhitelist),
      },
    ],
  },
];
